import {
  FETCH_START,
  FETCH_END,
  ADD_ELIGIBILITY_RULE_SUCCESS,
  ADD_ELIGIBILITY_RULE,
  ADD_ELIGIBILITY_RULE_FAILED,
  ADD_CALCULATION_RULE,
  CONTRACT_DATA,
  CONTRACT_DETAIL_DATA,
  ADD_CONTRACT_GENERAL_DATA,
  CLEAR_CONTRACT_SINGLE_DATA,
  ADD_CALCULATION_RULE_FAILED,
  CALCULATION_RULE_SUCCESS,
  CONTRACT_NUMBER,
  CONTRACT_DATA_COMPLETE,
  UPLOAD_ATTACHMENT_SUCCESS,
  UPLOAD_ATTACHMENT_RESET,
  FETCH_START_UPLOAD,
  FETCH_END_UPLOAD,
  SHOW_CONTRACT_POPUP,
  SECOND_CHANGED_CONTRACT_DETAIL_SUCCESS,
  CONTRACT_DATA_COMPARE,
  UPDATED_CONTRACT_LIST,
  CONTRACT_CHANGE_LOG,
  CONTRACT_ALL_APPTYPE,
  CONTRACT_DATA_LIST,
  CONTRACT_DATA_LIST_DASHBOARD,
  UPDATED_CONTRACT_ALL_LIST,
  FP_HISTORY_SUCCESS,
  MASS_CONTRACT_UPDATE,
  MASS_CONTRACT_UPDATE_ACTION,
  MASS_CONTRACT_UPDATE_ACTION_CLEAR,
  UPLOAD_CALCULATION_RULES_SUCCESS,
  RESET_UPLOAD_CALCULATION_RULES,
  APPROVAL_LEVEL_DATA,
  EXPIRY_DATA,
  CALCU_RULE_VALID_MSG,
  CONTRACT_RULES_DATA_API_SUCCESS,
  CALCU_RULE_VALID_CLEAR,
  UPLOAD_MULTIPLE_PAYMENT_SUCCESS,
  RESET_UPLOAD_MULTIPLE_PAYMENT,
  MULTI_PAY_VALDIATE_LEVEL_DATA,
  CLEAR_MULTI_PAY_VALDIATE_LEVEL_DATA,
  CONTRACT_VALIDATE_DATA,
  PREPAID_FORECAST_DATA,
} from '../../../actions/Contracts/AddContract/ActionTypes';

const initialState = {
  eligibilityRulesData: [],
  calculationRulesData: [],
  contractListData: [],
  contractDetailData: [],
  contractGeneralData: [],
  changedContractOldData: [],
  contractCompareData: [],
  contractChangeLog: {},
  contractNumber: 0,
  eligibilityAdded: false,
  loading: false,
  uploadUrl: '',
  loadingFile: false,
  showContractPopup: false,
  contractAllAppType: [],
  contractAllListData: [],
  contractAllListDataDashBoard: [],
  contractRulesDataList: [],
  fpHistoryData: {},
  massUpdate: [],
  massUpdateAction: [],
  calculationRulesUploadData: [],
  approvalLevelData: [],
  expiredData: [],
  calculationMessage: [],
  multiplePaymentUploadData: [],
  multiplePaymentValidationData: [],
  contractValidate: [],
  forecastScheduleData: [],
};

const AddContractReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ELIGIBILITY_RULE:
      return {
        ...state,
        eligibilityRulesData: action.data,
      };
    case ADD_ELIGIBILITY_RULE_SUCCESS:
      return {
        eligibilityAdded: true,
      };
    case ADD_ELIGIBILITY_RULE_FAILED:
      return {
        ...state,
        errorEligibilityAdd: true,
      };
    case ADD_CALCULATION_RULE:
      return {
        ...state,
        calculationRulesData: action.data,
      };
    case CONTRACT_DATA:
      return {
        ...state,
        contractListData: action.data,
      };
    case CONTRACT_DATA_COMPLETE:
      return {
        ...state,
        contractListDataComplete: action.data,
      };
    case CONTRACT_DETAIL_DATA:
      return {
        ...state,
        contractDetailData: action.data,
      };
    case ADD_CONTRACT_GENERAL_DATA:
      return {
        ...state,
        contractGeneralData: action.data,
      };
    case CLEAR_CONTRACT_SINGLE_DATA:
      return {
        ...state,
        contractGeneralData: [],
      };
    case CONTRACT_DATA_COMPARE:
      return {
        ...state,
        contractCompareData: action.data,
      };
    case ADD_CALCULATION_RULE_FAILED:
      return {
        ...state,
        errorCalculationAdd: true,
      };
    case CALCULATION_RULE_SUCCESS:
      return {
        ...state,
        calculationSuccess: true,
      };
    case CONTRACT_NUMBER:
      return {
        ...state,
        contractNumber: action.data,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case UPLOAD_ATTACHMENT_SUCCESS:
      return {
        ...state,
        uploadUrl: action.data,
      };
    case UPLOAD_ATTACHMENT_RESET:
      return {
        ...state,
        uploadUrl: '',
      };
    // Spread state: returning only `loadingFile` wiped the whole addContractData
    // slice on every attachment upload. uploadUrl is cleared on start so the
    // previous upload's URL can't be mistaken for this one's.
    case FETCH_START_UPLOAD:
      return {
        ...state,
        loadingFile: true,
        uploadUrl: '',
      };
    case FETCH_END_UPLOAD:
      return {
        ...state,
        loadingFile: false,
      };
    case SHOW_CONTRACT_POPUP:
      return {
        showContractPopup: action.data,
      };
    case SECOND_CHANGED_CONTRACT_DETAIL_SUCCESS:
      return {
        changedContractOldData: action.data,
      };
    case UPDATED_CONTRACT_LIST:
      return {
        ...state,
        updatedContractList: action.data,
      };
    case CONTRACT_CHANGE_LOG:
      return {
        ...state,
        contractChangeLog: action.data,
      };
    case CONTRACT_ALL_APPTYPE:
      return {
        ...state,
        contractAllAppType: action.data,
      };
    case CONTRACT_DATA_LIST:
      return {
        ...state,
        contractAllListData: action.data,
      };
    case CONTRACT_DATA_LIST_DASHBOARD:
      return {
        ...state,
        contractAllListDataDashBoard: action.data,
      };
    case CONTRACT_RULES_DATA_API_SUCCESS:
      return {
        ...state,
        contractRulesDataList: action.data,
      };
    case UPDATED_CONTRACT_ALL_LIST:
      return {
        ...state,
        updatedContractAllList: action.data,
      };
    case FP_HISTORY_SUCCESS:
      return {
        ...state,
        fpHistoryData: action.data,
      };
    case MASS_CONTRACT_UPDATE:
      return {
        ...state,
        massUpdate: action.data,
      };
    case MASS_CONTRACT_UPDATE_ACTION:
      return {
        ...state,
        massUpdateAction: action.data,
      };
    case MASS_CONTRACT_UPDATE_ACTION_CLEAR:
      return {
        ...state,
        massUpdateAction: [],
      }
    case UPLOAD_CALCULATION_RULES_SUCCESS:
      return {
        ...state,
        calculationRulesUploadData: action.data,
      };
    case RESET_UPLOAD_CALCULATION_RULES:
      return {
        ...state,
        calculationRulesUploadData: [],
      };
    case UPLOAD_MULTIPLE_PAYMENT_SUCCESS:
      return {
        ...state,
        multiplePaymentUploadData: action.data,
      };
    case RESET_UPLOAD_MULTIPLE_PAYMENT:
      return {
        ...state,
        multiplePaymentUploadData: [],
      };
    case MULTI_PAY_VALDIATE_LEVEL_DATA:
      return {
        ...state,
        multiplePaymentValidationData: action.data,
      }
    case CLEAR_MULTI_PAY_VALDIATE_LEVEL_DATA:
      return {
        ...state,
        multiplePaymentValidationData: [],
      }
    case APPROVAL_LEVEL_DATA:
      return {
        ...state,
        approvalLevelData: action.data,
      };
    case EXPIRY_DATA:
      return {
        ...state,
        expiredData: action.data,
      };
    case CALCU_RULE_VALID_MSG:
      return {
        ...state,
        calculationMessage: action.data,
      };
    case CALCU_RULE_VALID_CLEAR:
      return {
        ...state,
        calculationMessage: [],
      };
    case CONTRACT_VALIDATE_DATA:
      return {
        ...state,
        contractValidate: action.data,
      };
    case PREPAID_FORECAST_DATA:
      return {
        ...state,
        forecastScheduleData: action.data,
      };
    default:
      return state;
  }
};

export default AddContractReducer;
